const ConsultationStatus = {
  OPEN: 'open',
  CLOSE: 'close',
  RATED: 'rated'
}

export default ConsultationStatus
